import Link from "next/link";
import React from "react";

export default function MachineHeading({ machine, selectedDeckType }) {
  const cleanedMachineInfo = `${selectedDeckType}`.replace(/- 3b/g, '');

 
  return (
    <div className="heading-wrapper">
      <div className="title-wrapper">
        <div className="title-details">
          <h1 className="title">
            {machine.name}
            <span>
              {machine.version} {cleanedMachineInfo}
            </span>
          </h1>
          <span>{machine.style.data.attributes.style}</span>
        </div>
        <Link href="#machine-demo-request" className="request-demo-btn">
          Request a Demo
        </Link>
      </div>
    </div>
  );
}
